import { History, MessageSquareText } from 'lucide-react';
import { cn } from '@/lib/utils';
import type { TalkPanel } from '@/components/talk/useTalkSessionStore';

const panelItems: Array<{
  id: TalkPanel;
  label: string;
  icon: typeof MessageSquareText;
}> = [
  { id: 'chat', label: 'Chat', icon: MessageSquareText },
  { id: 'sessions', label: 'Threads', icon: MessageSquareText },
  { id: 'history', label: 'Versions', icon: History },
];

interface TalkSessionBottomNavProps {
  activePanel: TalkPanel;
  onChange: (panel: TalkPanel) => void;
}

export function TalkSessionBottomNav({
  activePanel,
  onChange,
}: TalkSessionBottomNavProps) {
  return (
    <nav className="fixed inset-x-0 bottom-0 z-30 border-t bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/85">
      <div className="grid grid-cols-3 gap-1 px-2 pb-[calc(env(safe-area-inset-bottom)+0.2rem)] pt-1">
        {panelItems.map((item) => {
          const Icon = item.icon;
          const active = item.id === activePanel;
          return (
            <button
              key={item.id}
              type="button"
              onClick={() => onChange(item.id)}
              className={cn(
                'flex min-h-[3rem] flex-col items-center justify-center rounded-xl px-1 py-1.5 text-[10px] font-medium transition-colors',
                active
                  ? 'bg-primary/10 text-primary'
                  : 'text-muted-foreground hover:bg-muted hover:text-foreground',
              )}
            >
              <Icon className="mb-0.5 h-4 w-4" />
              <span>{item.label}</span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}
